// removed by extract-text-webpack-plugin
module.exports = {"instheader":"loUlLW1MmHMZeGuxpFiPD","instsports":"_2Soy6WOSHCEUl8Ft_RbFHE","instsimplifique":"_3AVKhEhYH6ElpMorO4apQN","instparceiros":"keHgZL0pu4JDyF7xMBEfA","instcontent":"_1P2X1359SrxwmU4PzkagrO","instpublico":"_1MLAKeiEUKPUHWtfZyHstY","instmedida":"_2BmSU1hOpkmVJzlr7xCocB","instciclista":"_5lD97Uz4uZZ8h09ityp8y","instciclistatext":"_33r2cVcX0hBaeZ5s6DT_fz","boxVideo":"_1PaT1p_nCHZ2ZtaE34MbiW","boxVideo-active":"_3Dw-FNpm32j5l_5ihNfjNT"};


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Home/style.css
// module id = 325
// module chunks = 37